import React, { useEffect } from "react";
import { LuPlus } from "react-icons/lu";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { useNavigate } from "react-router-dom";
import { useLazyGetpatientdoctoroverviewQuery } from "../../State/Api/AddpatientApiSlice";


const DoctorPatientAppointment = ({
  patientOverviewData,
  patientUserUniqueID,
}) => {
  const navigate = useNavigate();
  const DoctorUserUniqueID=localStorage.getItem("userUniqueID");
  const [
    fetchpatientAppointments,
    { data: patientappointmentData = [], isFetching },
  ] = useLazyGetpatientdoctoroverviewQuery();

  useEffect(() => {
    if (patientUserUniqueID,DoctorUserUniqueID) {
      fetchpatientAppointments({patientUserUniqueID,DoctorUserUniqueID});
    }
  }, [patientUserUniqueID,DoctorUserUniqueID]);
  return (
    <div className="mt-2 space-y-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
      <div className="rounded-lg border bg-white shadow-sm">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4">
          <div>
            <h2 className="text-xl xl:text-2xl font-semibold mb-2 tracking-tight">
              Appointment History
            </h2>
            <div className="text-sm text-gray-500">
              View all appointments and medical visits.
            </div>
          </div>
          {/* <button
            onClick={() => {
              navigate("/AddAppointment", {
                state: {
                  showModal: true,
                  patientName: patientViewData?.basicInfo?.fullname,
                  fromPatientView: true,
                },
              });
            }}
            className="inline-flex items-center gap-2 rounded-md text-sm font-medium bg-[#171717] text-white hover:bg-[#2e2e2e] h-10 px-4 py-2 gradient-button"
          >
            <LuPlus className="h-4 w-4" /> Schedule Appointment
          </button> */}
        </div>

        {/* Static Table */}
        <div className="p-4">
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <table className="w-full text-sm text-left text-gray-500">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    Date & Time
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Type
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Doctor
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Status
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Notes
                  </th>
                  {/* <th scope="col" className="px-6 py-3">
                    Actions
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {Array.isArray(patientappointmentData) &&
                  patientappointmentData
                    .filter(
                      (appointment) => appointment?.status === "Completed"
                    )
                    .map((appointment) => (
                      <tr className="odd:bg-white even:bg-gray-50 border-b">
                        <td className="px-6 py-4">
                          <p>
                            {appointment?.appointmentDate
                              ? new Date(appointment.appointmentDate)
                                  .toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                  })
                                  .replace(/ /g, "-")
                              : "N/A"}
                          </p>
                        </td>
                        <td className="px-6 py-4">
                          {appointment?.appointmentType}
                        </td>
                        <td className="px-6 py-4">{appointment?.doctorName}</td>
                        <td className="px-6 py-4">
                          <span
                            className={`inline-flex items-center rounded-full text-white px-2.5 py-0.5 text-xs font-semibold
    ${
      appointment?.status === "Upcoming"
        ? "bg-yellow-500"
        : appointment?.status === "Today"
        ? "bg-red-500"
        : appointment?.status === "Completed"
        ? "bg-green-500"
        : "bg-gray-400"
    }
  `}
                          >
                            {appointment?.status}
                          </span>
                        </td>
                        <td className="px-6 py-4 max-w-[200px] truncate">
                          Patient reported feeling well. Blood pressure normal.
                        </td>
                        {/* <td className="px-6 py-4 relative">
                    <Popover className="relative">
                      <PopoverButton
                        type="button"
                        className="inline-flex items-center justify-center shrink-0 gap-2 rounded-md text-sm font-medium ring-offset-background transition-colors disabled:pointer-events-none disabled:opacity-50 hover:bg-gray-100 hover:text-black w-10 h-10"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-ellipsis h-4 w-4"
                        >
                          <circle cx="12" cy="12" r="1" />
                          <circle cx="19" cy="12" r="1" />
                          <circle cx="5" cy="12" r="1" />
                        </svg>
                        <span className="sr-only">Actions</span>
                      </PopoverButton>

                      <PopoverPanel className="absolute z-10 right-0 mt-2 w-48 rounded-md border border-gray-200 bg-white shadow-md">
                        <div className="p-3">
                          <h4 className="font-bold text-sm text-gray-800 mb-2">
                            Actions
                          </h4>
                          <ul className="space-y-2 text-sm text-gray-700">
                            <li className="flex items-center gap-2 hover:text-blue-600 cursor-pointer">
                              <span className="h-2 w-2 rounded-full bg-blue-600"></span>
                              view details
                            </li>
                            <li className="flex items-center gap-2 hover:text-yellow-500 cursor-pointer">
                              <span className="h-2 w-2 rounded-full bg-yellow-500"></span>
                              show list
                            </li>
                            <li className="flex items-center gap-2 hover:text-green-600 cursor-pointer">
                              <span className="h-2 w-2 rounded-full bg-green-600"></span>
                              download summary
                            </li>
                          </ul>
                        </div>
                      </PopoverPanel>
                    </Popover>
                  </td> */}
                      </tr>
                    ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorPatientAppointment;
